<template>
  <div class="case">
    <banner img="../assets/img/banner.png" />
    <div class="case-product">
      <div v-for="(item,index) in list"
           :key="index"
           class="case-item">
        <div>
          <div class="case-title"> {{item.title}}</div>
          <div class="case-des"> {{item.des}}</div>
          <img 
                  :src="detailImgFn(item.imgSrcName)"
                 alt="">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Banner from '../components/Banner';
export default {
  components: {
    Banner,
  },
  data() {
    return {
      pid: 0,
      caseIdList: [
        {
          list: [
            {
              title: '上海电信云协作项目',
              des: '“云协作”产品为上海电信云应用商店SaaS产品，主要为中小企业提供办公协作、业务权限管理、成果共享（知识库）等功能。',
              imgSrcName: 'shdx'
            },
          ],
        },
        {
          list: [
            {
              title: '上海消防语音项目',
              des: '上海市消防局调度录音查询系统提供录音管理收纳服务，是为上海市消防局实现一套安全、高效、便捷、稳定的录音管理功能。该系统上线后，具有权限的人员可以实现随时听取历史录音文件，并能实现远程下载来降低人力成本，提高工作效率。',
              imgSrcName: 'shxf'
            },
          ],
        },
        {
          list: [
            {
              title: '浙江星星冷链IOT监控平台项目',
              des: '浙江星星冷链集成股份有限公司是行业领先的冷链设备制造与综合服务提供商，主营业务为商用、商厨、家用及医用制冷设备的研发、生产与销售，还提供冷库工程建设服务及配套设备。其产品和方案已广泛应用于商超、便利店、农贸市场、酒店、餐饮企业、家庭、冷库仓储、医院、药店等众多场景。',
              imgSrcName: 'xxls'
            },
          ],
        },
        {
          list: [
            {
              title: '“香道泉羊”羊庄门店管理系统项目',
              des: '“香道泉羊”是一家新兴羊点品牌，为配合门店的发展需要，基于订单管理系统定制了其门店管理系统，包括了PC端和PAD使用的H5端。',
              imgSrcName: 'xdqy'
            },
          ],
        },
        {
          list: [
            {
              title: '杭州西湖区卫健局影像AI项目',
              des: '杭州西湖区卫健局下辖12家基层社区卫生服务中心，每家社区卫生服务中心都配备有DR影像设备，部分社区还配备了专业的CT影像设备。项目在西湖区医疗数据中心搭建深睿影像AI平台，通过区医疗云将影像人工智能技术赋能基层医疗机构。',
              imgSrcName: 'hzxhwjw'
            },
          ],
        },
        {
          list: [
            {
              title: '海市卫健委推广项目-AI助力分级诊疗项目',
              des: '基于智能影像云平台，AI提供了精准的人工智能处理建议，为专家、普通医生和患者建立稳定的线上关系。助力上海市胸科医院、上海市普陀区人民医院、上海市闵行区虹桥社区卫生服务中心三级医疗体系建设。扩大了市级医院的临床技术优势，加强了与区域医疗中心和社区卫生服务中心的合作协同。',
              imgSrcName: 'shwjw'
            },
          ],
        },
      ],
      list: [],
    };
  },
  created() {
    this.pid = this.$route.params.id - 1;
    window.console.log(this.pid);
    this.list = this.caseIdList[this.$route.params.id - 1].list;
  },
  mounted() {},
  methods: {
    detailImgFn(name) {
      return require(`../assets/kz/detail/${name}.jpg`);
    }
  },
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  &-item {
    display: flex;
  }
  &-img {
    width: 60px;
    height: 60px;
    margin-top: 14px;
    margin-right: 20px;
  }
  &-title {
    font-size: 64px;
    margin-bottom: 40px;
    font-weight: 600;
  }
  &-des {
    font-size: 24px;
    margin-bottom: 20px;
  }
  &-product {
    width: 1240px;
    margin: 40px auto;
    background-color: #fff;
  }
  .s {
    padding-left: 40px;
    background: url(../assets/kz/icon-dg.svg) no-repeat left 12px;
    background-size: 18px;
    margin-bottom: 45px;
    font-size: 30px;
    margin-bottom: 5px;
    font-weight: 600;
  }
  .s-des {
    padding-left: 40px;
    font-size: 24px;
    margin-bottom: 20px;
  }
}
</style>